var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("RoutingPlanTabHeader", {
        attrs: { "is-refreshing": _vm.vm.isRefreshingTargets },
        on: {
          refresh: _vm.vm.refreshTargets,
          "create-new": _vm.vm.openNewTargetModal
        },
        model: {
          value: _vm.filters.name.value,
          callback: function($$v) {
            _vm.$set(_vm.filters.name, "value", $$v)
          },
          expression: "filters.name.value"
        }
      }),
      _vm._v(" "),
      _vm.displayTargets.length
        ? _c(
            "div",
            { staticClass: "grid_table_holder p-10" },
            [
              _c(
                "v-table",
                {
                  staticClass: "table_beauty table-condensed",
                  attrs: {
                    data: _vm.displayTargets,
                    "current-page": _vm.currentPage,
                    "page-size": 10,
                    filters: _vm.filters,
                    "hide-sort-icons": true,
                    cellpadding: "0",
                    cellspacing: "0"
                  },
                  on: {
                    "update:currentPage": function($event) {
                      _vm.currentPage = $event
                    },
                    "update:current-page": function($event) {
                      _vm.currentPage = $event
                    },
                    totalPagesChanged: function($event) {
                      _vm.totalPages = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body",
                        fn: function({ displayData }) {
                          return _c(
                            "tbody",
                            {},
                            _vm._l(displayData, function(target) {
                              return _c("tr", { key: target.id }, [
                                _c(
                                  "td",
                                  { attrs: { align: "left" } },
                                  [
                                    _c("LinkedName", {
                                      attrs: {
                                        href: _vm.getHref(
                                          "dashboard.target.edit",
                                          {
                                            targetId: target.id,
                                            name: target.name
                                          }
                                        ),
                                        title: target.name
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", { attrs: { align: "center" } }, [
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.right.hover",
                                        value: _vm.$t(
                                          target.instructions.callType == "sip"
                                            ? "TARGETS_TYPE_SIP"
                                            : "TARGETS_TYPE_NUMBER"
                                        ),
                                        expression:
                                          "$t(target.instructions.callType == 'sip' ? 'TARGETS_TYPE_SIP' : 'TARGETS_TYPE_NUMBER')",
                                        modifiers: { right: true, hover: true }
                                      }
                                    ],
                                    class:
                                      target.instructions.callType == "sip"
                                        ? "typcn typcn-point-of-interest-outline"
                                        : "typcn typcn-phone-outline"
                                  })
                                ]),
                                _vm._v(" "),
                                _c("td", { attrs: { align: "left" } }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        target.instructions.callType ===
                                          "number"
                                          ? target.instructions.number
                                          : target.instructions.sip.number
                                      ) +
                                      "\n          "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("TargetStatus", {
                                      attrs: { entity: target }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", { attrs: { align: "center" } }, [
                                  _c("a", {
                                    staticClass:
                                      "btn btn-list-function typcn typcn-arrow-right-thick",
                                    attrs: { href: "javascript:;" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.vm.openNewTargetRouteModal(
                                          target
                                        )
                                      }
                                    }
                                  })
                                ])
                              ])
                            }),
                            0
                          )
                        }
                      }
                    ],
                    null,
                    false,
                    661674891
                  )
                },
                [
                  _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
                    _c(
                      "tr",
                      [
                        _c("v-th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "CAMPAIGN_STEP_ROUTING_TARGETS_NAME",
                              expression: "'CAMPAIGN_STEP_ROUTING_TARGETS_NAME'"
                            }
                          ],
                          staticClass: "column-sortable width-30-percent",
                          attrs: {
                            align: "left",
                            "sort-key": "name",
                            "default-sort": "asc"
                          }
                        }),
                        _vm._v(" "),
                        _c("v-th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "CAMPAIGN_STEP_ROUTING_TARGETS_TYPE",
                              expression: "'CAMPAIGN_STEP_ROUTING_TARGETS_TYPE'"
                            }
                          ],
                          staticClass: "column-sortable",
                          attrs: { "sort-key": "type", align: "center" }
                        }),
                        _vm._v(" "),
                        _c("v-th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "CAMPAIGN_STEP_ROUTING_TARGETS_NUMBER",
                              expression:
                                "'CAMPAIGN_STEP_ROUTING_TARGETS_NUMBER'"
                            }
                          ],
                          staticClass: "column-sortable",
                          attrs: { "sort-key": "number", align: "left" }
                        }),
                        _vm._v(" "),
                        _c("v-th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "CAMPAIGN_STEP_ROUTING_TARGETS_STATUS",
                              expression:
                                "'CAMPAIGN_STEP_ROUTING_TARGETS_STATUS'"
                            }
                          ],
                          staticClass: "column-sortable",
                          attrs: {
                            "sort-key": t =>
                              t.tStatus.isAcceptingCalls +
                              t.tStatus.blockReason,
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "CAMPAIGN_STEP_ROUTING_TARGETS_ADD",
                              expression: "'CAMPAIGN_STEP_ROUTING_TARGETS_ADD'"
                            }
                          ],
                          attrs: { align: "center" }
                        })
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "pagination-min" }, [
                _c(
                  "div",
                  { staticClass: "text-center p-0" },
                  [
                    _c("smart-pagination", {
                      attrs: {
                        "current-page": _vm.currentPage,
                        "total-pages": _vm.totalPages,
                        "max-page-links": 5
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.vm.isLoading
        ? _c("LoadingStatusDisplay", { attrs: { loading: true } }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("CAMPAIGN_STEP_ROUTING_LOADING_TARGETS")) +
                "\n  "
            )
          ])
        : !_vm.vm.targets.length
        ? _c("div", { staticClass: "col-xs-12" }, [
            _vm._v("\n    " + _vm._s(_vm.noTargetAvailableMessage) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.vm.modal != null
        ? [
            _vm.vm.modal.type === "new-target"
              ? _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        return _vm.vm.closeModal()
                      }
                    }
                  },
                  [_c("br")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.vm.openNewTargetRouteModal
              ? _c("RoutingNewTargetRoute", {
                  attrs: {
                    "selected-target": _vm.vm.modal.target,
                    "route-container": _vm.context.routeContainer,
                    "route-container-type": _vm.context.routeContainerType,
                    "current-route": _vm.vm.modal.route || {},
                    "is-rpc": _vm.vm.modal.target.isRpc || false
                  },
                  on: {
                    cancel: _vm.vm.closeModal,
                    "create-update": _vm.vm.closeModal
                  }
                })
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }